import React from 'react';

export default function Footer() {
  return (
    <footer className="footerContainer">Feito por Leandro Oliveira para o processo seletivo do IPAM</footer>
  );
}
